import type { RootState } from "~/redux/store";

import { type KmatType } from "~/Configurators/Linear/getKmatType";
import type { Kmat, LinearConfiguration, LinearConfigurationUpdate } from "~/Configurators/Linear/models";

/**
 * Determines whether a specified step has been visited.
 *
 * @param {number} stepNumber - The number of the step to check. 1 based
 */
export function hasVisitedStep(stepNumber: number) {
  return (state: RootState) => {
    const highestStepVisited = state.linearConfigurator.highTideStep;
    return highestStepVisited >= stepNumber - 1;
  };
}

export function allCsticsHaveValue(kmatType: KmatType, ...csticNames: string[]) {
  return (state: RootState) => {
    return (
      state.linearConfigurator.kmats[kmatType]?.every((kmat) => {
        const cstics = kmat.cstics;
        return csticNames.every((name) => !!cstics[name]?.value);
      }) ?? false
    );
  };
}
export function allCsticsHaveValueInConfiguration(kmatType: KmatType, ...csticNames: string[]) {
  return (model: LinearConfiguration | LinearConfigurationUpdate) => {
    return (
      model.kmats[kmatType]?.every((kmat) => {
        const cstics = kmat.cstics;
        return csticNames.every((name) => !!cstics[name]?.value);
      }) ?? false
    );
  };
}

export function getMainKmat({ kmats }: { kmats: Dict<Kmat[]> }) {
  return Object.values(kmats)
    .flatMap((k) => k)
    .find((kmat) => !kmat.parentId)!;
}

export function selectMainKmat(state: RootState) {
  return getMainKmat({
    kmats: state.linearConfigurator.kmats,
  });
}
